import React from "react";
import { Button, Card, EmptyState } from "@nelurio/ui";
import { Link } from "react-router";
import { useI18n } from "@nelurio/i18n";

export function NotFoundPage() {
  const { t } = useI18n();
  return <div className="narrow-page"><Card><EmptyState icon="route" title={t("notfound.title")} description={t("notfound.body")} action={<Link to="/"><Button>{t("nav.dashboard")}</Button></Link>} /></Card></div>;
}
